import { motion, useInView } from "framer-motion";
import { FC, ReactNode, useRef } from "react";

interface TextBlockProps {
    children?: ReactNode;
    title?: string;
}

export const TextBlock: FC<TextBlockProps> = ({
    children,
    title
}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0.3, y: 150 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 150 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="px-3 sm:p-0 flex flex-col gap-2"
        >
            {title && <p className="font-bold text-2xl sm:text-3xl">
                {title}
            </p>}
            {children}
        </motion.div>
    )
}